import { WorkspacePanelDto } from '@mark43/cad-api';
import { expandablePanelSizeConfig } from './expandable-panel-size';
import { DEFAULT_EVENT_PANEL_HEIGHT, defaultDimensionsByPanelType } from './panel-configuration';

/**
 * This is to get the correct size for newly opened workspace panels via use-open-workspace-panel.
 */
export function getWorkspacePanelSize(
    type: WorkspacePanelDto['workspacePanelType'],
    eventPanelCompactByDefault: boolean
) {
    if (type === 'EVENT' || type === 'SCHEDULED_EVENT') {
        return {
            width: eventPanelCompactByDefault
                ? expandablePanelSizeConfig.NORMAL
                : expandablePanelSizeConfig.XL,
            height: DEFAULT_EVENT_PANEL_HEIGHT,
        };
    }

    return {
        width: defaultDimensionsByPanelType[type]?.[0] ?? 800,
        height: defaultDimensionsByPanelType[type]?.[1] ?? 600,
    };
}
